<template>
  <input :id="inputId" type="radio" class="o-star" name="rating" :value="value" @change="ratingSelected" />
</template>

<script lang="ts">
export default {
  name: 'Star',
  props: {
    score: { type: Number },
    selectedCallback: { type: Function },
    value: { type: String },
  },
  computed: {
    inputId(): string {
      return `star${this.score}`;
    },
  },
  methods: {
    ratingSelected() {
      this.selectedCallback(this.value);
    },
  },
};
</script>
